import script from "./VideoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoComponent.vue?vue&type=script&setup=true&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=371da8a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-371da8a8"]])

export default __exports__